"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Static asset location
var assetLoc = "https://static.granular.ag/common/gds-assets/latest/lib/images/logos";
// Granular
var GLogo = assetLoc + "/granular-logo.svg";
var GLogoLH = assetLoc + "/granular-logo-lockup-h.svg";
var GLogoLV = assetLoc + "/granular-logo-lockup-v.svg";
var GLogoW = assetLoc + "/granular-logo-white.svg";
var GLogoLHW = assetLoc + "/granular-logo-lockup-h-white.svg";
var GLogoLVW = assetLoc + "/granular-logo-lockup-v-white.svg";
var GLogoLHD = assetLoc + "/granular-logo-lockup-h-dark.svg";
var GLogoLVD = assetLoc + "/granular-logo-lockup-v-dark.svg";
var GLogoT = assetLoc + "/granular-logotype.svg";
var GLogoTW = assetLoc + "/granular-logotype-white.svg";
// Granular sub-brands
// default is horizontal lockup for sub-brand logos
var AgronomyLogoLH = assetLoc + "/granular-agronomy-logo-lockup-h.svg";
var AgronomyLogoLV = assetLoc + "/granular-agronomy-logo-lockup-v.svg";
var AgronomyLogoLHW = assetLoc + "/granular-agronomy-logo-lockup-h-white.svg";
var AgronomyLogoLVW = assetLoc + "/granular-agronomy-logo-lockup-v-white.svg";
var AgronomyLogoLHD = assetLoc + "/granular-agronomy-logo-lockup-h-dark.svg";
var AgronomyLogoLVD = assetLoc + "/granular-agronomy-logo-lockup-v-dark.svg";
var AgronomyLogoT = assetLoc + "/granular-agronomy-logotype.svg";
var AgronomyLogoTW = assetLoc + "/granular-agronomy-logotype-white.svg";
var BusinessLogoLH = assetLoc + "/granular-business-logo-lockup-h.svg";
var BusinessLogoLV = assetLoc + "/granular-business-logo-lockup-v.svg";
var BusinessLogoLHW = assetLoc + "/granular-business-logo-lockup-h-white.svg";
var BusinessLogoLVW = assetLoc + "/granular-business-logo-lockup-v-white.svg";
var BusinessLogoLHD = assetLoc + "/granular-business-logo-lockup-h-dark.svg";
var BusinessLogoLVD = assetLoc + "/granular-business-logo-lockup-v-dark.svg";
var BusinessLogoT = assetLoc + "/granular-business-logotype.svg";
var BusinessLogoTW = assetLoc + "/granular-business-logotype-white.svg";
var InsightsLogoLH = assetLoc + "/granular-insights-logo-lockup-h.svg";
var InsightsLogoLV = assetLoc + "/granular-insights-logo-lockup-v.svg";
var InsightsLogoLHW = assetLoc + "/granular-insights-logo-lockup-h-white.svg";
var InsightsLogoLVW = assetLoc + "/granular-insights-logo-lockup-v-white.svg";
var InsightsLogoLHD = assetLoc + "/granular-insights-logo-lockup-h-dark.svg";
var InsightsLogoLVD = assetLoc + "/granular-insights-logo-lockup-v-dark.svg";
var InsightsLogoT = assetLoc + "/granular-insights-logotype.svg";
var InsightsLogoTW = assetLoc + "/granular-insights-logotype-white.svg";
// Visor brands
// default is horizontal lockup for visor logos
var LandVisorLogoLH = assetLoc + "/landvisor-logo-lockup-h.svg";
var LandVisorLogoLV = assetLoc + "/landvisor-logo-lockup-v.svg";
var LandVisorLogoLHW = assetLoc + "/landvisor-logo-lockup-h-white.svg";
var LandVisorLogoLVW = assetLoc + "/landvisor-logo-lockup-v-white.svg";
var LandVisorLogoLHD = assetLoc + "/landvisor-logo-lockup-h-dark.svg";
var LandVisorLogoLVD = assetLoc + "/landvisor-logo-lockup-v-dark.svg";
var LandVisorLogoT = assetLoc + "/landvisor-logotype.svg";
var LandVisorLogoTW = assetLoc + "/landvisor-logotype-white.svg";
var LandVisorLogoIcon = assetLoc + "/landvisor-logo-icon.svg";
var LandVisorLogoIconW = assetLoc + "/landvisor-logo-icon-white.svg";
// Corteva brands
var CortevaLogoLHD = assetLoc + "/corteva-logo-lockup-h-dark.svg";
var CortevaLogoLHW = assetLoc + "/corteva-logo-lockup-h-white.svg";
var CortevaLogoLH = assetLoc + "/corteva-logo-lockup-h.svg";
var CortevaLogoLVD = assetLoc + "/corteva-logo-lockup-v-dark.svg";
var CortevaLogoLVW = assetLoc + "/corteva-logo-lockup-v-white.svg";
var CortevaLogoLV = assetLoc + "/corteva-logo-lockup-v.svg";
var CortevaLogoW = assetLoc + "/corteva-logo-white.svg";
var CortevaLogo = assetLoc + "/corteva-logo.svg";
var CortevaLogoTW = assetLoc + "/corteva-logotype-white.svg";
var CortevaLogoT = assetLoc + "/corteva-logotype.svg";
// Pioneer brands
var PioneerLogoLD = assetLoc + "/pioneer-logo-black.svg";
var PioneerLogoLHD = assetLoc + "/pioneer-logo-lockup-h-black.svg";
var PioneerLogoLHW = assetLoc + "/pioneer-logo-lockup-h-white.svg";
var PioneerLogoLH = assetLoc + "/pioneer-logo-lockup-h.svg";
var PioneerLogoLVW = assetLoc + "/pioneer-logo-lockup-v-white.svg";
var PioneerLogoLVD = assetLoc + "/pioneer-logo-lockup-v-black.svg";
var PioneerLogoW = assetLoc + "/pioneer-logo-white.svg";
var PioneerLogoLV = assetLoc + "/pioneer-logo-lockup-v.svg";
var PioneerLogo = assetLoc + "/pioneer-logo.svg";
var PioneerLogoTD = assetLoc + "/pioneer-logotype-black.svg";
var PioneerLogoTW = assetLoc + "/pioneer-logotype-white.svg";
var PioneerLogoT = assetLoc + "/pioneer-logotype.svg";
// Hoegemeyer brands
var HoegemeyerLogoLD = assetLoc + "/hoegemeyer-logo-black.svg";
var HoegemeyerLogoLHD = assetLoc + "/hoegemeyer-logo-lockup-h-black.svg";
var HoegemeyerLogoLHW = assetLoc + "/hoegemeyer-logo-lockup-h-white.svg";
var HoegemeyerLogoLH = assetLoc + "/hoegemeyer-logo-lockup-h.svg";
var HoegemeyerLogoLVW = assetLoc + "/hoegemeyer-logo-lockup-v-white.svg";
var HoegemeyerLogoLVD = assetLoc + "/hoegemeyer-logo-lockup-v-black.svg";
var HoegemeyerLogoW = assetLoc + "/hoegemeyer-logo-white.svg";
var HoegemeyerLogoLV = assetLoc + "/hoegemeyer-logo-lockup-v.svg";
var HoegemeyerLogo = assetLoc + "/hoegemeyer-logo.svg";
var HoegemeyerLogoTD = assetLoc + "/hoegemeyer-logotype-black.svg";
var HoegemeyerLogoTW = assetLoc + "/hoegemeyer-logotype-white.svg";
var HoegemeyerLogoT = assetLoc + "/hoegemeyer-logotype.svg";
// Brevant brands
var BrevantLogoLD = assetLoc + "/brevant-logo-black.svg";
var BrevantLogoLHD = assetLoc + "/brevant-logo-lockup-h-black.svg";
var BrevantLogoLHW = assetLoc + "/brevant-logo-lockup-h-white.svg";
var BrevantLogoLH = assetLoc + "/brevant-logo-lockup-h.svg";
var BrevantLogoLVW = assetLoc + "/brevant-logo-lockup-v-white.svg";
var BrevantLogoLVD = assetLoc + "/brevant-logo-lockup-v-black.svg";
var BrevantLogoW = assetLoc + "/brevant-logo-white.svg";
var BrevantLogoLV = assetLoc + "/brevant-logo-lockup-v.svg";
var BrevantLogo = assetLoc + "/brevant-logo.svg";
exports.default = {
    GLogo: GLogo,
    GLogoLH: GLogoLH,
    GLogoLV: GLogoLV,
    GLogoW: GLogoW,
    GLogoLHW: GLogoLHW,
    GLogoLVW: GLogoLVW,
    GLogoLHD: GLogoLHD,
    GLogoLVD: GLogoLVD,
    GLogoT: GLogoT,
    GLogoTW: GLogoTW,
    AgronomyLogoLH: AgronomyLogoLH,
    AgronomyLogoLV: AgronomyLogoLV,
    AgronomyLogoLHW: AgronomyLogoLHW,
    AgronomyLogoLVW: AgronomyLogoLVW,
    AgronomyLogoLHD: AgronomyLogoLHD,
    AgronomyLogoLVD: AgronomyLogoLVD,
    AgronomyLogoT: AgronomyLogoT,
    AgronomyLogoTW: AgronomyLogoTW,
    BusinessLogoLH: BusinessLogoLH,
    BusinessLogoLV: BusinessLogoLV,
    BusinessLogoLHW: BusinessLogoLHW,
    BusinessLogoLVW: BusinessLogoLVW,
    BusinessLogoLHD: BusinessLogoLHD,
    BusinessLogoLVD: BusinessLogoLVD,
    BusinessLogoT: BusinessLogoT,
    BusinessLogoTW: BusinessLogoTW,
    CortevaLogo: CortevaLogo,
    CortevaLogoLH: CortevaLogoLH,
    CortevaLogoLHD: CortevaLogoLHD,
    CortevaLogoLHW: CortevaLogoLHW,
    CortevaLogoT: CortevaLogoT,
    CortevaLogoTW: CortevaLogoTW,
    CortevaLogoLV: CortevaLogoLV,
    CortevaLogoLVD: CortevaLogoLVD,
    CortevaLogoLVW: CortevaLogoLVW,
    CortevaLogoW: CortevaLogoW,
    InsightsLogoLH: InsightsLogoLH,
    InsightsLogoLV: InsightsLogoLV,
    InsightsLogoLHW: InsightsLogoLHW,
    InsightsLogoLVW: InsightsLogoLVW,
    InsightsLogoLHD: InsightsLogoLHD,
    InsightsLogoLVD: InsightsLogoLVD,
    InsightsLogoT: InsightsLogoT,
    InsightsLogoTW: InsightsLogoTW,
    LandVisorLogoLH: LandVisorLogoLH,
    LandVisorLogoLV: LandVisorLogoLV,
    LandVisorLogoLHW: LandVisorLogoLHW,
    LandVisorLogoLVW: LandVisorLogoLVW,
    LandVisorLogoLHD: LandVisorLogoLHD,
    LandVisorLogoLVD: LandVisorLogoLVD,
    LandVisorLogoT: LandVisorLogoT,
    LandVisorLogoTW: LandVisorLogoTW,
    LandVisorLogoIcon: LandVisorLogoIcon,
    LandVisorLogoIconW: LandVisorLogoIconW,
    PioneerLogoLD: PioneerLogoLD,
    PioneerLogoLHD: PioneerLogoLHD,
    PioneerLogoLHW: PioneerLogoLHW,
    PioneerLogoLH: PioneerLogoLH,
    PioneerLogoLVW: PioneerLogoLVW,
    PioneerLogoLVD: PioneerLogoLVD,
    PioneerLogoW: PioneerLogoW,
    PioneerLogoLV: PioneerLogoLV,
    PioneerLogo: PioneerLogo,
    PioneerLogoTD: PioneerLogoTD,
    PioneerLogoTW: PioneerLogoTW,
    PioneerLogoT: PioneerLogoT,
    HoegemeyerLogoLD: HoegemeyerLogoLD,
    HoegemeyerLogoLHD: HoegemeyerLogoLHD,
    HoegemeyerLogoLHW: HoegemeyerLogoLHW,
    HoegemeyerLogoLH: HoegemeyerLogoLH,
    HoegemeyerLogoLVW: HoegemeyerLogoLVW,
    HoegemeyerLogoLVD: HoegemeyerLogoLVD,
    HoegemeyerLogoW: HoegemeyerLogoW,
    HoegemeyerLogoLV: HoegemeyerLogoLV,
    HoegemeyerLogo: HoegemeyerLogo,
    HoegemeyerLogoTD: HoegemeyerLogoTD,
    HoegemeyerLogoTW: HoegemeyerLogoTW,
    HoegemeyerLogoT: HoegemeyerLogoT,
    BrevantLogoLD: BrevantLogoLD,
    BrevantLogoLHD: BrevantLogoLHD,
    BrevantLogoLHW: BrevantLogoLHW,
    BrevantLogoLH: BrevantLogoLH,
    BrevantLogoLVW: BrevantLogoLVW,
    BrevantLogoLVD: BrevantLogoLVD,
    BrevantLogoW: BrevantLogoW,
    BrevantLogoLV: BrevantLogoLV,
    BrevantLogo: BrevantLogo,
};
